module.exports = __webpack_public_path__ + "b127e4392ca270dc80e4cc4a382f9489.png";